import { render, staticRenderFns } from "./PlayByPlay.vue?vue&type=template&id=310e889e&scoped=true&"
import script from "./PlayByPlay.vue?vue&type=script&lang=js&"
export * from "./PlayByPlay.vue?vue&type=script&lang=js&"
import style0 from "./PlayByPlay.vue?vue&type=style&index=0&id=310e889e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310e889e",
  null
  
)

export default component.exports